import { useRef, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import Menu from "src/components/Menu";
import { DarkMode } from "src/styling/Modes";
import LabeledCameraList from "./LabeledCameraList";
import SectionedCameraList from "./SectionedCameraList";

export default function CameraPicker({
  cameraList,
  isOpen,
  onClose,
  isParentStation,
  handleCameraChange,
  selectedCameraId,
  left = 0,
  alert
}) {
  const isChangingRef = useRef(false);

  useEffect(() => {
    isChangingRef.current = false;
  }, [selectedCameraId, alert]);

  async function changeCamera(cameraId) {
    if (cameraId === selectedCameraId || isChangingRef.current) return;
    isChangingRef.current = true;
    await handleCameraChange(cameraId);
    isChangingRef.current = false;
  }

  return (
    <DarkMode adjuster={(colors) => ({ urfaceElevated1: colors.black70 })}>
      <Menu
        anchorEl={<Box />}
        anchorProps={{
          position: "fixed",
          left: `${left}px`,
          top: "5px"
        }}
        isOpen={isOpen}
        onClose={onClose}
      >
        {isParentStation ? (
          <SectionedCameraList
            cameraList={cameraList}
            handleCameraChange={changeCamera}
            selectedCameraId={selectedCameraId}
          />
        ) : (
          <LabeledCameraList
            cameraList={cameraList}
            handleCameraChange={changeCamera}
            selectedCameraId={selectedCameraId}
          />
        )}
      </Menu>
    </DarkMode>
  );
}
